namespace $ { $mol_style_attach( "mol/svg/root/root.view.css",
 "[mol_svg_root] {\n\toverflow: hidden;\n}\n"
) }